import styles from "./HamburgerButton.module.css";
function HamburgerButton({ id, onClick, ghost, dark, className }) {
    function handleClick() {
        if (!ghost) {
            onClick?.call();
        }
    }

    return (
        <button
            id={id}
            onClick={handleClick}
            className={[
                styles.hamburger_button,
                dark ? styles.dark : "",
                className,
            ].join(" ")}
            aria-label="Open navigation menu"
        >
            <div className={styles.line}></div>
            <div className={styles.line}></div>
            <div className={styles.line}></div>
        </button>
    );
}

export default HamburgerButton;
